import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpClient } from "@angular/common/http";

import { HttpService } from '../../../../shared/ajs-bridges/http.service';
import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';
import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { ModeleOuvrageTLR } from '../entities/modele-ouvrage-tlr.entity';

@Injectable({ providedIn: 'root' })
export class ModeleOuvrageService {
	private path: string;
	private subService!: BasicDataSubService<ModeleOuvrageTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: ModeleOuvrageService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let serverDataChanged$ = cachedDataSurveyService.getChangeNotification("ModeleOuvrage");
		this.subService = new BasicDataSubService<ModeleOuvrageTLR>(httpClient, this.path + 'modelesOuvrage?format=TLR', serverDataChanged$);
	}
	
	/////////////////////////////////////////////////////////////////////////
	// Fonctions pour compatibilite avec les anciens composants Angular-JS
	/////////////////////////////////////////////////////////////////////////

	// Methode recuperant toutes les modelesOuvrage.
	public getModeleOuvrages(): Promise<any> {
		let url = this.path + 'modelesOuvrage/';
		let result = this.httpService.get(url);
		return result;
	}

	// Methode recuperant toutes les modelesOuvrage groupés par classe d'ouvrage'.
	public getModeleOuvragesGroupedByClasse(): Promise<any> {
		let url = this.path + 'modelesOuvrage/groupedByClasse';
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant de recuperer une modeleOuvrage a partir de son identifiant.
	public getModeleOuvrageById(id: number): Promise<any> {
		let url = this.path + 'modelesOuvrage/' + id;
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant d'ajouter une modeleOuvrage.
	public create(data: any): Promise<any> {
		let url = this.path + 'modelesOuvrage/';
		let result = this.httpService.post(url, data);
		return result;
	}

	// Methode permettant de modifier une modeleOuvrage.
	public update(id: number, data: any): Promise<any> {
		let url = this.path + 'modelesOuvrage/' + id;
		let result = this.httpService.put(url, data);
		return result;
	}

	// Methode permettant de supprimer un modeleOuvrage.
	public deleteModeleOuvrage(id: number): Promise<any> {
		let url = this.path + 'modelesOuvrage/' + id;
		let result = this.httpService.delete(url);
		return result;
	}
	
	/////////////////////////////////////////////////////////////////////////
	// Fonctions pour les nouveaux composants Angular 12+
	/////////////////////////////////////////////////////////////////////////

	// Methode permettant le chargement de toutes les entites
	public getList = () => this.subService.getList();

	// Methodes permettant le chargement de tous les entities, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getMapById = () => this.subService.getMapById();
	public getById = (id: number) => this.subService.getKnownById(id, "ModeleOuvrageTLR");
}

angular
	.module('auroraApp')
	.service('modelesOuvrageService', downgradeInjectable(ModeleOuvrageService));